/* FJC: return-to-spot on collection pages.
   Pairs with snippets/fjc-back-button.liquid (PDP "< BACK" button).

   On a collection page, remember which product the customer clicked.
   When they come back via back-navigation and the page is NOT served from
   bfcache (fresh load, Globo re-renders the grid async), poll for that
   product's card and scroll it into view — the reliable "same place",
   independent of grid height changes. Aborts if the user scrolls first. */
(function () {
  var KEY = 'fjcBackSpot';
  var MAX_AGE_MS = 10 * 60 * 1000;

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
      if (!a) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([a-zA-Z0-9-]+)/);
      if (!m) return;
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ p: location.pathname, h: m[1], t: Date.now() }));
      } catch (err) {}
    },
    true
  );

  function findCard(handle) {
    var links = document.querySelectorAll('a[href*="/products/' + handle + '"]');
    for (var i = 0; i < links.length; i++) {
      try {
        var path = new URL(links[i].href, location.origin).pathname;
        var h = path.split('/products/')[1];
        if (h && h.split('/')[0].split('?')[0] === handle) return links[i];
      } catch (err) {}
    }
    return null;
  }

  function restore() {
    var data;
    try {
      data = JSON.parse(sessionStorage.getItem(KEY));
    } catch (err) {
      return;
    }
    if (!data || data.p !== location.pathname || Date.now() - data.t > MAX_AGE_MS) return;

    var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (nav && nav.type !== 'back_forward') return;

    var cancelled = false;
    var onUser = function () {
      cancelled = true;
    };
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, onUser, { passive: true, once: true });
    });

    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (cancelled || tries > 25) {
        clearInterval(timer);
        return;
      }
      var card = findCard(data.h);
      if (card) {
        clearInterval(timer);
        try {
          sessionStorage.removeItem(KEY);
        } catch (err) {}
        card.scrollIntoView({ block: 'center' });
      }
    }, 200);
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      /* bfcache hit: browser restored scroll + loaded pages perfectly */
      try {
        sessionStorage.removeItem(KEY);
      } catch (err) {}
      return;
    }
    restore();
  });
})();

/* FJC 2026-10-28: keep the collection search box in step with the URL.
   Globo's search box (#gf-controls-search-input) writes the term to ?q= and
   filters the grid by it, but on a fresh load of that URL (back from a product
   when the page is not served from bfcache, or a refresh) Globo filters by q
   yet draws the box empty. Put the term back in the box; value only, no input
   event, so Globo does not search again. /search uses the theme's own box. */
(function () {
  function fillSearchBox() {
    var input = document.getElementById('gf-controls-search-input');
    if (!input || input.value) return;
    var q = new URLSearchParams(location.search).get('q');
    if (q) input.value = q;
  }

  window.addEventListener('globoFilterRenderCompleted', fillSearchBox);
  document.addEventListener('DOMContentLoaded', fillSearchBox);
})();
